// extracted by mini-css-extract-plugin
module.exports = {"main":"SelectedFood_main__2sEfL"};